import { ARTICLE_ROUTE_PATH } from './app-routes';

import { setWpLoggedInStatus } from '../../lib/server-request';

const { BASE_URI } = process.env;

/**
 * Define all server side data dependencies here. These requests will be run in series
 * before server side rendering. This ensures all dependency calls have been completed
 * before the hydrated store is passed to the render function.
 */
const dataDependencies = [
  {
    path: BASE_URI,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, no-unused-vars -- directive added automatically by Shepherd migration
    loadData: ({ store, req, res, match, location }, callback) => {
      callback();
    },
    routes: [
      {
        path: `${BASE_URI}${ARTICLE_ROUTE_PATH}`,
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, no-unused-vars -- directive added automatically by Shepherd migration
        loadData: ({ store, req, res, match, location }, callback) => {
          // Set WP logged-in status flag.
          setWpLoggedInStatus(req, store);

          callback();
        },
      },
    ],
  },
];

export default dataDependencies;
